import React, { useState } from 'react'
import {
  MemoryRouter as Router,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom'
import useAuth0ClientConfig from './lib/auth0/use-auth0-client-config'
import useNotificationsManager from './lib/notifications/use-notifications-manager'
import NotificationsContext from './lib/notifications/context'
import getInitialNotifications, {
  NotificationFlags,
} from './lib/initialNotifications'
import ScrollToTop from './components/scroll-to-top'
import Layout from './pages/layout'
import VerifyCodePage from './pages/verify-code'
import LoginPage from './pages/login'
import SignUpPage from './pages/sign-up'
import CreatePasswordPage from './pages/create-password'
import NotFoundPage from './pages/not-found'
import ErrorPage from './pages/error'
import * as paths from './pages/paths'
import './App.scss'

export enum InitialScreen {
  signup = 'signup',
  login = 'login',
  create_new_password = 'create_new_password',
}

const getInitialRoute = (initialScreen?: string) => {
  switch (initialScreen) {
    case InitialScreen.signup:
      return paths.SIGN_UP
    case InitialScreen.create_new_password:
      return paths.CREATE_NEW_PASSWORD
    default:
      return paths.LOGIN
  }
}

interface Props {
  initialScreen?: string
  initialNotificationFlags?: NotificationFlags
}

const App: React.FC<Props> = (props) => {
  const [draftEmail, setDraftEmail] = useState('')
  const [email, setEmail] = useState('')
  //this will be use for GA
  const [actionName, setActionName] = useState('')
  const { consumerUrl } = useAuth0ClientConfig()

  const forgotPasswordUrl = `${consumerUrl}${paths.FORGOT_PASSWORD}`
  const initialNotifications = getInitialNotifications({
    forgotPasswordUrl,
    initialNotificationFlags: props.initialNotificationFlags,
  })
  const notificationsManager = useNotificationsManager({ initialNotifications })

  return (
    <NotificationsContext.Provider value={notificationsManager}>
      <Router>
        <ScrollToTop />

        <Layout>
          <Switch>
            <Route exact path={paths.HOME}>
              <Redirect
                to={{
                  pathname: paths.DEFAULT,
                  state: { isInitialRedirect: true },
                }}
              />
            </Route>

            <Route exact path={paths.DEFAULT}>
              <Redirect
                to={{
                  pathname: getInitialRoute(props.initialScreen),
                  state: { isInitialRedirect: true },
                }}
              />
            </Route>

            <Route exact path={paths.SIGN_UP}>
              <SignUpPage
                draftEmail={draftEmail}
                setEmail={setEmail}
                setDraftEmail={setDraftEmail}
                setActionName={setActionName}
              />
            </Route>

            <Route exact path={paths.LOGIN}>
              <LoginPage
                draftEmail={draftEmail}
                setEmail={setEmail}
                setDraftEmail={setDraftEmail}
                forgotPasswordUrl={forgotPasswordUrl}
              />
            </Route>

            <Route exact path={paths.CREATE_NEW_PASSWORD}>
              <CreatePasswordPage
                draftEmail={draftEmail}
                setEmail={setEmail}
                setDraftEmail={setDraftEmail}
                setActionName={setActionName}
              />
            </Route>

            <Route exact path={paths.VERIFY_CODE}>
              <VerifyCodePage email={email} actionName={actionName} />
            </Route>

            <Route exact path={'/50x'}>
              <ErrorPage />
            </Route>

            <Route>
              <NotFoundPage />
            </Route>
          </Switch>
        </Layout>
      </Router>
    </NotificationsContext.Provider>
  )
}

export default App
